export default {"src":"/_next/static/media/icons8-linkedin.a564461b.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};